var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.info.controls == "1" ? _c("a-radio-group", {
    on: {
      change: function ($event) {
        return _vm.informChange("radio");
      }
    },
    model: {
      value: _vm.info.controlsDefaultValue,
      callback: function ($$v) {
        _vm.$set(_vm.info, "controlsDefaultValue", $$v);
      },
      expression: "info.controlsDefaultValue"
    }
  }, _vm._l(_vm.info.controlsValue, function (item, index) {
    return _c("a-radio", {
      key: index,
      attrs: {
        value: item.name,
        disabled: !item.disabled
      }
    }, [_vm._v(_vm._s(_vm.unitReplace(item.name)))]);
  }), 1) : _vm.info.controls == "2" ? _c("div", [_vm.info.mark == "age" ? _c("div", {}, [_c("a-select", {
    staticStyle: {
      width: "20%"
    },
    attrs: {
      placeholder: _vm.$t("请选择"),
      disabled: _vm.info.disabled
    },
    on: {
      change: function ($event) {
        return _vm.changeAge(_vm.info.controlsDefaultType);
      }
    },
    model: {
      value: _vm.info.controlsDefaultType,
      callback: function ($$v) {
        _vm.$set(_vm.info, "controlsDefaultType", $$v);
      },
      expression: "info.controlsDefaultType"
    }
  }, _vm._l(_vm.info.controlsValue, function (item, i) {
    return _c("a-select-option", {
      key: i,
      attrs: {
        value: item.type
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(item.name)) + " ")]);
  }), 1), _c("a-input", {
    staticStyle: {
      width: "calc(80% - 20px)",
      "margin-left": "20px"
    },
    attrs: {
      disabled: !_vm.info.controlsDefaultType || _vm.info.disabled,
      placeholder: _vm.$t("请先选择年龄类型")
    },
    on: {
      change: _vm.changeAgeNumber,
      blur: function ($event) {
        _vm.$emit("disabledAge"), _vm.changeAgeNumber(true);
      }
    },
    model: {
      value: _vm.info.controlsDefaultValue,
      callback: function ($$v) {
        _vm.$set(_vm.info, "controlsDefaultValue", $$v);
      },
      expression: "info.controlsDefaultValue"
    }
  })], 1) : _c("a-date-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      disabled: _vm.info.controlsDefaultValue ? true : false,
      format: _vm.getFormatDate(),
      allowClear: false
    },
    on: {
      change: _vm.informChange
    },
    model: {
      value: _vm.info.controlsDefaultValue,
      callback: function ($$v) {
        _vm.$set(_vm.info, "controlsDefaultValue", $$v);
      },
      expression: "info.controlsDefaultValue"
    }
  })], 1) : _vm.info.controls == "3" ? _c("div", [_vm.info.mark == "areaPrice" ? _c("a-cascader", {
    attrs: {
      allowClear: false,
      disabled: _vm.info.controlsDefaultValue.length ? true : false,
      options: _vm.areaList,
      "field-names": {
        label: "name",
        value: "code",
        children: "child",
        disabled: "disabled"
      },
      placeholder: _vm.$t("请选择") + _vm.info.name
    },
    on: {
      change: _vm.informChange
    },
    model: {
      value: _vm.info.controlsDefaultValue,
      callback: function ($$v) {
        _vm.$set(_vm.info, "controlsDefaultValue", $$v);
      },
      expression: "info.controlsDefaultValue"
    }
  }) : _c("a-cascader", {
    attrs: {
      allowClear: false,
      "field-names": {
        label: "name",
        value: "name",
        children: "child",
        disabled: "disabled"
      },
      options: _vm.info.controlsValue,
      placeholder: _vm.$t("请选择") + _vm.info.name
    },
    on: {
      change: function ($event) {
        return _vm.informChange("cascader");
      }
    },
    model: {
      value: _vm.info.controlsDefaultValue,
      callback: function ($$v) {
        _vm.$set(_vm.info, "controlsDefaultValue", $$v);
      },
      expression: "info.controlsDefaultValue"
    }
  })], 1) : _vm.info.controls == "4" ? _c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.info.name
    },
    on: {
      change: _vm.informChange
    },
    model: {
      value: _vm.info.controlsDefaultValue,
      callback: function ($$v) {
        _vm.$set(_vm.info, "controlsDefaultValue", $$v);
      },
      expression: "info.controlsDefaultValue"
    }
  }) : _vm.info.controls == "5" ? _c("a-checkbox-group", {
    on: {
      change: function ($event) {
        return _vm.informChange("checkbox");
      }
    },
    model: {
      value: _vm.info.controlsDefaultValue,
      callback: function ($$v) {
        _vm.$set(_vm.info, "controlsDefaultValue", $$v);
      },
      expression: "info.controlsDefaultValue"
    }
  }, _vm._l(_vm.info.controlsValue, function (item, i) {
    return _c("a-checkbox", {
      key: i,
      attrs: {
        value: item.value,
        disabled: !item.disabled
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1) : _vm.info.controls == "6" ? _c("a-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.info.name
    },
    on: {
      change: function ($event) {
        return _vm.informChange("select");
      }
    },
    model: {
      value: _vm.info.controlsDefaultValue,
      callback: function ($$v) {
        _vm.$set(_vm.info, "controlsDefaultValue", $$v);
      },
      expression: "info.controlsDefaultValue"
    }
  }, _vm._l(_vm.info.controlsValue, function (item, i) {
    return _c("a-select-option", {
      key: i,
      attrs: {
        value: item.name,
        disabled: !item.disabled
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };